import React from "react";
import moment from 'moment';
import { daterangepicker_ranges, daterangepicker_locale } from "../Constants";
import SearchTable from './SearchTable';
import {formatPrice} from "../Format";

export default class SearchTableRefund extends SearchTable {
    params = {
        sort_field: 'created',
        sort_order: 'desc',
        daterange: moment().startOf('month').format('DD.MM.YYYY') + ' - ' + moment().endOf('month').format('DD.MM.YYYY'),
        page: 1
    };
    formId = 'transfer-search-form';
    varPrefix = 'searchTableTransfer';
    loadParamsRegExp = [
        /\/refund\/(.*)/g
    ];
    submit_proceed = [
        'download',
        'download_details'
    ];

    apiUrl = '/api/refunds';
    sortDef = [
        { key: 'created', name: 'Erstellt' },
        { key: 'iban', name: 'Konto: IBAN'},
        { key: 'bic', name: 'Konto: BIC'},
        { key: 'value', name: 'Umsatz'},
        { key: 'invoice_number'}
    ];
    colDef = [
        { sortField: 'created', text: 'Datum' },
        { sortField: 'iban', text: 'Konto' },
        { sortField: 'invoice_number', text: 'Gutschriftsnummer'},
        { sortField: 'value', text: 'Umsatz' },
        { text: 'Status' },
        { text: 'Aktionen' }
    ];

    init() {
        super.init();
        $('#daterange').daterangepicker({
            startDate: moment().startOf('month'),
            endDate: moment().endOf('month'),
            ranges: daterangepicker_ranges,
            locale: daterangepicker_locale
        }, (start, end, label) => this.daterangepickerSubmit(start, end, label));
    }
    
    renderTableRow(row) {
        return (
            <tr key={`refund-${row.id}`}>
                {this.renderDate(row)}
                {this.renderTableCellAccount(row)}
                {this.renderInvoiceNumber(row)}
                {this.renderTableCellValuePrice(row)}
                {this.renderStatus(row)}
                {this.renderTableCellActions(row)}
            </tr>
        )
    }

    renderDate(row) {
        return(
            <td>
                {this.formatDate(row.created)}<br/>
                <small>{row.uid}</small>
            </td>
        )
    }

    renderTableCellAccount(row) {
        return (
            <td>
                <a href={'/account/' + row.account_id + '/show'}>{this.formatAccountIBAN(row.account_iban)}</a><br/>
                <small>BIC: {row.account_bic}</small>
            </td>
        )
    }

    renderInvoiceNumber(row) {
        return(
            <td>
                {row.invoice_number}<br/>
                {this.renderOperatorSubline(row)}
            </td>
        )
    }

    renderOperatorSubline(row) {
        if (!this.operatorEnabled)
            return '';
        if (!row.operator)
            return '';
        return (
            <small><a href={'/operator/' + row.operator.id + '/show'}>{row.operator.name}</a></small>
        )
    }

    renderTableCellValuePrice(row) {
        return(
            <td>
                {formatPrice(row.value)}<br/>
                <small>Netto: {formatPrice(row.value_subtotal)}</small>
            </td>
        )
    }

    renderStatus(row) {
        return (
            <td>
                {this.renderStatusIcon('check-circle', row.completed, 'Abgerechnet: ' + this.formatDate(row.processed_at))}
                {this.renderStatusIcon('file-text', row.refund_generated_at, 'Rechnung generiert: ' + this.formatDate(row.refund_generated_at))}
            </td>
        )
    }

    renderTableCellActions(row) {
        return(
            <td>
                {this.renderTableCellActionIcon('/refund/' + row.id + '/show', 'info', 'anzeigen', true)}
            </td>
        )
    }
}